<template>
  <div>
    <b-sidebar
      class="sidebar"
      bg-variant="white"
      text-variant="success"
      aria-labelledby="Hosachiguri"
      no-header
      shadow
      width="298px"
      :no-close-on-route-change="true"
      :no-close-on-esc="true"
      visible
    >
      <img
        class="logo"
        src="@/assets/logo.png"
        alt="Hosachiguru Logo"
      />

      <div>
        <nav class="mb-3">
          <b-nav vertical>
            <b-nav-item class="nav-item" to="/"
              ><i class="fas fa-house-user nav-icon"></i>Home</b-nav-item
            >
            <b-nav-item to="/users" class="nav-item">
              <i class="fas fa-user-friends nav-icon"></i>Users
            </b-nav-item>

            <b-nav-item to="/projects" class="nav-item">
              <i class="fas fa-layer-group nav-icon"></i>Farms</b-nav-item
            >

            <!-- <b-nav-item to="/projects/resorts" class="nav-item">
              <i class="fas fa-align-justify nav-icon"></i>Farm
              Retreats</b-nav-item
            >

            <b-nav-item to="/book-farm-retreat" class="nav-item">
              <i class="fas fa-wave-square nav-icon"></i>Book
              Cottages</b-nav-item
            > -->

            <!-- <b-nav-item to="/farm-retreat-bookings" class="nav-item">
              <i class="fas fa-swatchbook nav-icon"></i
              ><span class="">Cottage Booking List</span>
            </b-nav-item> -->
      <b-nav-item
  target="__blank"
  :href="`${getBaseURLV2()}/plantation?token=${GetLoggedInToken}`" 
  class="nav-item"
>
  <i class="fas fa-coins nav-icon"></i>Plantation
</b-nav-item>


            <!-- <b-nav-item to="/asset" class="nav-item"
              ><i class="fas fa-coins nav-icon"></i>Assets</b-nav-item
            > -->

            <b-nav-item to="/announcement" class="nav-item"
              ><i
                class="fas fa-bullhorn nav-icon"
                style="margin-right: 13px"
              ></i>
              Announcements</b-nav-item
            >

            <b-nav-item to="/activities" class="nav-item"
              ><i class="fas fa-tractor nav-icon"></i> Activities</b-nav-item
            >
            <b-nav-item to="/work-orders" class="nav-item"
              ><i class="fas fa-book nav-icon"></i> Work Orders</b-nav-item
            >

            <li class="nav-item nav-item">

              <a
              :href="getBaseURL()+'?token='+ GetLoggedInToken"
              target="__blank"
              class="nav-link">
              <svg class="svg-inline--fa fa-swatchbook fa-w-16 nav-icon" aria-hidden="true"
              focusable="false" data-prefix="fas" data-icon="swatchbook"
               role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
               data-fa-i2svg="">
               <path fill="currentColor" d="M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"></path></svg><!-- <i class="fas fa-swatchbook nav-icon"></i> Font Awesome fontawesome.com -->
               Farm Stay </a>
            </li>
              <b-nav-item
            target="__blank"
            :href="getBaseURL()+'/reports/activities?token='+ GetLoggedInToken" class="nav-item"
              ><i class="fas fa-book nav-icon"></i> Reports</b-nav-item
            >
      <b-nav-item
  target="__blank"
  :href="`${getBaseURLV2()}/credits?token=${GetLoggedInToken}`" 
  class="nav-item"
>
  <i class="fas fa-dollar-sign nav-icon"></i>Credits
</b-nav-item>
              </b-nav>

        </nav>
      </div>
    </b-sidebar>

    <b-navbar toggleable="lg" variant="white" class="topnav">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <b-row no-gutters>
                <b-col cols="3">
                  <i
                    class="fas fa-user-circle user-icon"
                    aria-hidden="true"
                  ></i>
                </b-col>
                <b-col cols="8 mt-2">
                  <span class="name">{{ LoggedInName }}</span>
                  <br />
                </b-col>
              </b-row>
            </template>
            <b-dropdown-item to="/organization">Organization</b-dropdown-item>
            <b-dropdown-item href="#">Profile</b-dropdown-item>
            <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="container-fluid" style="padding-left: 298px">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLayout",
  components: {},
  data(){
    return {
      token: '',
    }
  },
  computed: {
    LoggedInName: function() {
      return this.$store.getters.LoggedInName;
    },
    GetLoggedInToken(){
      return this.$store.getters.getToken;
    }
  },
  methods: {
    getBaseURL() {
      let VUE_APP_NEW_APP_URL = process.env.VUE_APP_NEW_APP_URL;
      if (VUE_APP_NEW_APP_URL == "") {
        alert("Please Setup VUE_NEW_APP_URL value in the env")
        process.exit(1);
      }
      return VUE_APP_NEW_APP_URL;
    },
    getBaseURLV2() {
      let VUE_APP_NEW_APP_URL = process.env.VUE_APP_APP_URL_V2;
      if (VUE_APP_NEW_APP_URL == "") {
        alert("Please Setup VUE_NEW_APP_URL value in the env")
        process.exit(1);
      }
      return VUE_APP_NEW_APP_URL;
    },
    async logout() {
      await this.$store.dispatch("LogOut");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style>
.topnav {
  margin-top: 10px;
}
.topnav .name {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  color: #525252;
  letter-spacing: 3.5%;
  font-size: 18px;
}
.topnav .heading {
  color: #888888;
  font-family: "Poppins";
  font-weight: 400;
  font-size: 20px;
  height: 30px;
  line-height: 30px;
  letter-spacing: 3.5%;
  height: 27px;
}
.topnav .user-icon {
  height: 47px;
  width: 45px;
  margin-right: 14px;
}
.topnav .dropdown-toggle {
  outline: none;
}
.topnav .dropdown-toggle::after {
  display: none;
}
.sidebar .logo {
  margin: 33px 38px;
}
.sidebar .nav-item {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  width: 298px;
  height: 62px;
  font-size: 15px;
  letter-spacing: 3.5%;
  line-height: 30px;
  color: #656565;
}
.sidebar .nav-icon,
.nav-icon:hover {
  width: 21px;
  height: 15px;
  margin-right: 16px;
  color: #656565;
  margin-left: 34px;
  text-decoration: none;
}

.sidebar .nav-link {
  color: #656565;
  text-decoration: none;
}

.nav-item .router-link-exact-active {
  background-color: #1da040;
  width: 298px;
  height: 55px;
  color: #fff;
}

.nav-item .router-link-exact-active .nav-icon {
  color: #fff;
}
</style>
